import { Grid, makeStyles, Typography } from "@material-ui/core"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import { Instagram } from "@material-ui/icons"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"

import { INSTAGRAM_URL, BIGHEAD_URL, SHOP } from "../../constants"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "black",
  },
  iconsWrapper: {
    borderTop: "2px solid white",
    borderBottom: "2px solid white",
  },
  iconsContainer: {
    padding: "2rem",
    maxWidth: "80rem",
    marginRight: "auto",
    marginLeft: "auto",
  },
  iconContainer: {
    maxWidth: "10rem",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "12rem",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "14rem",
    },
  },
  columnLink: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  link: {
    color: "white",
    marginTop: "1rem",
  },
  infoContainer: {
    padding: "2rem",
    maxWidth: "80rem",
    marginRight: "auto",
    marginLeft: "auto",
  },
  bottomContainer: {
    background: "linear-gradient(to bottom, red, maroon 20%, blue 100%)",
    height: "5rem",
    color: "white",
  },
}))

// アイコン+テキストラベルの1列分。3列で繰り返される構造を共通化。
// 同じ遷移先への重複リンクを避けるため、アイコンとラベルは1つのリンクで包み、
// アイコン画像は装飾扱い(alt="")にしてラベルテキストをアクセシブルネームにする
const FooterIconColumn = ({ classes, to, href, label, icon }) => {
  const content = (
    <>
      <div>{icon}</div>
      <Typography
        variant="body2"
        className={classes.link}
        style={{ fontFamily: "ヒラギノ丸ゴ ProN W4" }}
      >
        {label}
      </Typography>
    </>
  )
  return (
    <Grid item xs={4} className={classes.iconContainer}>
      {to ? (
        <Link to={to} className={classes.columnLink}>
          {content}
        </Link>
      ) : (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.columnLink}
        >
          {content}
        </a>
      )}
    </Grid>
  )
}

const Footer = () => {
  const classes = useStyles()
  const breakpoints = useBreakpoint()

  return (
    <footer>
      <Grid container direction="column" className={classes.root}>
        <div className={classes.iconsWrapper}>
          <Grid
            item
            container
            justifyContent="space-around"
            alignItems="flex-end"
            className={classes.iconsContainer}
          >
            <FooterIconColumn
              classes={classes}
              to="/menu"
              label="MENU/価格表"
              icon={
                breakpoints.xs ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/menu_icon.png"
                    alt=""
                    width={40}
                  />
                ) : breakpoints.sm ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/menu_icon.png"
                    alt=""
                    width={50}
                  />
                ) : breakpoints.md ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/menu_icon.png"
                    alt=""
                    width={60}
                  />
                ) : (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/menu_icon.png"
                    alt=""
                    width={70}
                  />
                )
              }
            />
            <FooterIconColumn
              classes={classes}
              href={INSTAGRAM_URL}
              label="ギャラリー"
              icon={
                breakpoints.xs ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/home_icon.jpg"
                    alt=""
                    width={50}
                  />
                ) : breakpoints.sm ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/home_icon.jpg"
                    alt=""
                    width={60}
                  />
                ) : breakpoints.md ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/home_icon.jpg"
                    alt=""
                    width={70}
                  />
                ) : (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/home_icon.jpg"
                    alt=""
                    width={80}
                  />
                )
              }
            />
            <FooterIconColumn
              classes={classes}
              to="/access"
              label="アクセス"
              icon={
                breakpoints.xs ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/car_icon.jpg"
                    alt=""
                    width={70}
                  />
                ) : breakpoints.sm ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/car_icon.jpg"
                    alt=""
                    width={80}
                  />
                ) : breakpoints.md ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/car_icon.jpg"
                    alt=""
                    width={90}
                  />
                ) : (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/car_icon.jpg"
                    alt=""
                    width={100}
                  />
                )
              }
            />
          </Grid>
        </div>
        <Grid
          item
          container
          className={classes.infoContainer}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            sm={6}
            style={{ textAlign: "center", marginBottom: "1.2rem" }}
          >
            <a href={BIGHEAD_URL} target="_blank" rel="noopener noreferrer">
              {breakpoints.xs ? (
                <StaticImage
                  placeholder="blurred"
                  src="../../images/bighead_txt.png"
                  alt="美容室BIGHEAD"
                  width={200}
                />
              ) : breakpoints.sm ? (
                <StaticImage
                  placeholder="blurred"
                  src="../../images/bighead_txt.png"
                  alt="美容室BIGHEAD"
                  width={300}
                />
              ) : breakpoints.md ? (
                <StaticImage
                  placeholder="blurred"
                  src="../../images/bighead_txt.png"
                  alt="美容室BIGHEAD"
                  width={400}
                />
              ) : (
                <StaticImage
                  placeholder="blurred"
                  src="../../images/bighead_txt.png"
                  alt="美容室BIGHEAD"
                  width={500}
                />
              )}
              <Typography
                style={{
                  color: "white",
                  textDecoration: "underline",
                  fontFamily:
                    "Hiragino Maru Gothic Pro, Hiragino Maru Gothic ProN, Meiryo, sans-serif",
                }}
                align="center"
              >
                ホームページはこちら
              </Typography>
            </a>
          </Grid>
          <Grid item container xs={12} sm={6} direction="column">
            <Grid item>
              <Typography
                variant="h4"
                component="p"
                align="right"
                style={{ fontFamily: "ヒラギノ丸ゴ ProN W4" }}
              >
                <span style={{ color: "white" }}>〒{SHOP.postalCode}</span>
                <br />
                <span style={{ color: "white" }}>
                  {SHOP.addressRegion}
                  {SHOP.addressLocality}
                  {SHOP.streetAddress}
                </span>
                <br />
                <span style={{ color: "magenta" }}>
                  営業時間：{SHOP.openingHours}
                </span>
                <br />
                <span style={{ color: "orange" }}>
                  定休日：{SHOP.closedDays}
                </span>
                <br />
                <span style={{ color: "white" }}>{SHOP.reservationNote}</span>
                <br />
              </Typography>
            </Grid>
            <Grid
              container
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid item>
                {breakpoints.xs ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/phone_icon.jpg"
                    alt="電話"
                    width={34}
                  />
                ) : breakpoints.sm ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/phone_icon.jpg"
                    alt="電話"
                    width={44}
                  />
                ) : breakpoints.md ? (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/phone_icon.jpg"
                    alt="電話"
                    width={54}
                  />
                ) : (
                  <StaticImage
                    placeholder="blurred"
                    src="../../images/phone_icon.jpg"
                    alt="電話"
                    width={60}
                  />
                )}
              </Grid>
              <Grid item>
                <a href={`tel:${SHOP.telephone}`}>
                  <span
                    style={{
                      color: "cyan",
                      fontSize: "3.2rem",
                      textDecoration: "underline",
                    }}
                  >
                    {SHOP.telephone}
                  </span>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          className={classes.bottomContainer}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagramギャラリー(新しいタブで開きます)"
            >
              <Instagram style={{ fontSize: "3rem" }} />
            </a>
          </Grid>
        </Grid>
      </Grid>
    </footer>
  )
}
export default Footer
